"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_DeviceDefinition_UdiDeviceIdentifier = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
exports.RTTI_DeviceDefinition_UdiDeviceIdentifier = t.recursion('IDeviceDefinition_UdiDeviceIdentifier', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        deviceIdentifier: t.string,
        _deviceIdentifier: RTTI_Element_1.RTTI_Element,
        issuer: RTTI_uri_1.RTTI_uri,
        _issuer: RTTI_Element_1.RTTI_Element,
        jurisdiction: RTTI_uri_1.RTTI_uri,
        _jurisdiction: RTTI_Element_1.RTTI_Element
    });
});
//# sourceMappingURL=RTTI_DeviceDefinition_UdiDeviceIdentifier.js.map